import { render, staticRenderFns } from "./AccTransactionList.vue?vue&type=template&id=2cbc3f29&scoped=true"
import script from "./AccTransactionList.vue?vue&type=script&lang=js"
export * from "./AccTransactionList.vue?vue&type=script&lang=js"
import style0 from "./AccTransactionList.vue?vue&type=style&index=0&id=2cbc3f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc3f29",
  null
  
)

export default component.exports